export var TooltipResult;

!function(TooltipResult) {
    TooltipResult[TooltipResult.success = 0] = "success", TooltipResult[TooltipResult.failed = 1] = "failed";
}(TooltipResult || (TooltipResult = {}));
//# sourceMappingURL=common.js.map
